import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
// import { getChatConversation, pushMessage } from "./actions/voice.community";

import { enableMapSet } from "immer";
import pusherMessageClient from "../../app/pusher";
import { RootState } from "../../app/store";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { getChatConversations, getChatMessages, pushMessage } from "./actions";
import { IChatMessages, IMyChats, ITempMessage } from "./chat.interface";

enableMapSet();

export const chatAdapter = createEntityAdapter<IChatMessages>({
  // Assume IDs are stored in a field other than `book.id`
  selectId: (chat) => chat.id,
  // Keep the "all IDs" array sorted based on book titles
  // sortComparer: (a, b) => a.chatroom_id(b.title),
});

const initialState = {
  myChats: [] as IMyChats[],
  chatMessages: [] as IChatMessages[],
  isChatsLoading: false,
  isMessagesLoading: false,
  tempMessage: [] as ITempMessage[],
};

export const textChatSlice = createSlice({
  name: "chat",
  initialState: chatAdapter.getInitialState({ ...initialState }),
  reducers: {
    reset: (state) => chatAdapter.getInitialState({ ...initialState }),

    pushNewMessage: (state, action) => {
      chatAdapter.addOne(state, action.payload);
    },
    
    pushChatMessage: (state, action) => {
      state.chatMessages.push(action.payload)
      console.log("all the payload",action.payload)
     const chatIndex = state.myChats.findIndex(chatId => (
        String(chatId.id) === String(action.payload.chatroom_id)
     ))
      if (chatIndex < 0) {
        console.log("error occured o")
        return
      }
      state.myChats[chatIndex].last_message.unshift(action.payload)
    },

    pushTempMessage: (state, action) => {
      state.tempMessage.push(action.payload);
    },

    removeTempMessage: (state, action) => {
      const startIndex = state.tempMessage.findIndex(
        (data) => String(data.temp_key) === String(action.payload)
      );
      console.log("remove index", startIndex)
      console.log("payload", action.payload)
      
      if (startIndex < 0) return;
        state.tempMessage.splice(startIndex, 1);
    },
  },

  extraReducers: (builder) => {
    
    builder.addCase(getChatConversations.pending, (state, action) => {
      state.isChatsLoading = true;
    });

    builder.addCase(getChatConversations.fulfilled, (state, action) => {
      if (action?.payload === undefined) return;

        // chatAdapter.upsertMany(state, action.payload);
        // state.
        state.isChatsLoading = false;
      state.myChats = action.payload;
      pusherMessageClient().subscribeToAllChatRooms(action.payload);
    });

    builder.addCase(getChatConversations.rejected, (state, action) => {
      NotificationAlert("failed", "Error", "Error while getting your chats");
      state.isChatsLoading = true;
    });
    
    builder.addCase(getChatMessages.fulfilled, (state, action: any) => {
      console.log("fulfilled");
      if (action?.payload === undefined) return;
      console.log(action.payload, "data for message");
      // chatAdapter.upsertMany(state, action.payload);
      state.chatMessages = action.payload
      state.isMessagesLoading = false;
      console.log(state.ids);
    });
    
    builder.addCase(getChatMessages.pending, (state, action) => {
      state.isMessagesLoading = true;
    });
    
    builder.addCase(getChatMessages.rejected, (state, action) => {
      NotificationAlert("failed", "Error", "Error while getting your chats");
      state.isMessagesLoading = true;
    });
    
    builder.addCase(pushMessage.fulfilled, (state, action: any) => {
      console.log("fulfilled");
      if (action?.payload === undefined) return;
      chatAdapter.addOne(state, action.payload);

    });
    
    builder.addCase(pushMessage.pending, (state, action) => {
      // state.isChatsLoading = true;
    });
    
    builder.addCase(pushMessage.rejected, (state, action) => {
      NotificationAlert("failed", "Error", "Error while getting your chats");
      // state.isChatsLoading = true;
    });
  },
});
export const conversationSelector = chatAdapter.getSelectors(
  (state: RootState) => state.textChat
);
